import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";

// Kanban Board View
import Board from "react-trello";
import "../Assets/css/style.css";
import Label from "../components/Label";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  FormControl,
  CircularProgress
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Select from "react-select";
import Page from "../components/Page";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import {
  featchleadhistory,
  fetchallcitylist,
  fetchallocatelistbyid
} from "src/utils/common";
import {
  getNewLeadDataForExport,
  getFollowupLeadList,
  insertLead,
  leadTransferTO,
  updateLeadMemberForm,
  updateleadstatus,
  insertMemberLeadRejectReason,
  getLeadRejectReason,
  getAttributeListApi,
  deleteLeadAttachment
} from "src/api/commonapi";
import moment from "moment";
import LimitedTextField from "src/components/LimitedTextField";
import { notification } from "src/utils/messages";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import {
  AutoGraphSharp,
  EditSharp,
  LeaderboardSharp,
  PersonAddAltSharp,
  SendSharp,
  ThumbUpAlt,
  Person,
  AddPhotoAlternate,
  ChangeCircle,
  Check,
  Close
} from "@mui/icons-material";
import { Routes } from "src/constant/api_url";
import { getLeadByLid, insertFollowUp } from "../api/commonapi";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { gender, IsNotValue, leadDetailsModelStyle, leadFollowupStyle, LeadSearchTypeOptions } from "src/constant/variable";
import { useLocation } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";
import CustomLaneHeader from "src/components/CustomLaneHeader";
import LeadStatusDescriptionViewModal from "./LeadStatusDescriptionViewModal";
export default function FollowupLeads() {
  const loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();

  const [step, setStep] = useState(0);
  const [formdata, setformdata] = useState({
    l_created_by: loginUser.u_id,
    l_type: 0,
    gender: 0
  });
  const [myModal, setMyModal] = useState({
    mval: false,
    lead_id: 0,
    l_phase: 1
  });
  const [statusList, setStatusList] = useState([]);
  const [boardLoading, setBoardLoading] = useState(false);
  const [allocatelist, setallocatelist] = useState([]);
  const [leadHistory, setLeadHistory] = useState([]);
  const [filterlead, setfilterlead] = useState({
    u_id: loginUser.u_id,
    u_type: loginUser.u_type,
    filterl: "",
    s_date: null,
    e_date: null,
    filteruser: 0,
    l_phase: location.state?.l_phase ?? -1,
    lead_status: location.state?.lead_status ?? -1,
    lead_type: -1,
    filterCity:
      loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : location.state?.city || 0
    // user_allocated: 0,
  });
  const [activeTab, setActiveTab] = useState(1);
  const [filterOption, setFilterOption] = useState([{ value: 0, label: "All Users" }]);
  const [allCityList, setAllCityList] = useState([]);
  const [newleadData, setnewLeadData] = useState([]);
  const [followUpModal, setFollowUpModal] = useState(false);
  const [followUpData, setFollowUpData] = useState({ u_id: loginUser.u_id });
  const [leadtransModal, setLeadTransModal] = useState(false);
  const [leadtransData, setLeadTransData] = useState({ u_id: loginUser.u_id });
  const [rejectmemberModal, setrejectmemberModal] = useState(false);
  const [rejectReasonData, setRejectReasonData] = useState({
    l_r_reason_id: 0
  });
  const [rejectReasonlist, setRejectReasonlist] = useState([]);
  const [leadStatusDescriptionViewModal, setLeadStatusDescriptionViewModal] = useState(false);
  const [leadStatusData, setLeadStatusData] = useState("");
  const [value, setValue] = useState("1");
  const [expanded, setExpanded] = useState(0);
  const [leadStatusChangeModal, setLeadStatusChangeModal] = useState(false);
  const [leadStatusChangeData, setLeadStatusChangeData] = useState({
    lead_id: 0, // Lead ID
    l_phase: 1, // Updated Lead Status
    u_id: loginUser?.u_id || 0, // User ID
    from_l_phase: 0, // Old Lead Status
    l_type: ""
  });
  const [newLan, setNewLan] = useState({
    allLeadList: [],
    allLeadIds: [],
    followupLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    processingLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    confirmLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    rejectedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  });
  const [loading, setLoading] = useState(false);
  const [loadingMoreData, setLoadingMoreData] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);

  const closeLeadStatusChangeModal = () => {
    setLeadStatusChangeModal(false);
    setLeadStatusChangeData({
      lead_id: 0, // Lead ID
      l_phase: 1, // Updated Lead Status
      u_id: loginUser?.u_id || 0, // User ID
      from_l_phase: 0, // Old Lead Status
      l_type: ""
    });
  };

  const handleGetAttributeList = async () => {
    const resp = await getAttributeListApi();
    if (resp.status == 1) {
      const filteredAttributesList = resp.data?.filter((item) => item.a_id == 3 || item.a_id == 9 || item.a_id == 4 || item.a_id == 8);
      setStatusList(filteredAttributesList);
    }
  };

  const deleteLeadAttachmentHandler = async (
    lead_id,
    delete_file_key = "",
    name,
    l_p_photo_id,
    index
  ) => {
    const resp = await deleteLeadAttachment({ lead_id, delete_file_key, name, l_p_photo_id });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      if (delete_file_key === "l_payment_photo") {
        setformdata((prev) => ({
          ...prev,
          l_payment_photo: prev.l_payment_photo.filter((_, ind) => ind !== index),
          l_payment_photo_id: prev.l_payment_photo_id.filter((_, ind) => ind !== index)
        }));
      } else if (delete_file_key === "aadhaar") setformdata({ ...formdata, aadhaar: "" });
      else if (delete_file_key === "l_professional_photo")
        setformdata({ ...formdata, l_professional_photo: "" });
    }
  };

  const getallcitylist = async () => {
    setAllCityList(await fetchallcitylist());
  };

  const initNewLan = {
    allLeadList: [],
    allLeadIds: [],
    followupLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    processingLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    confirmLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    rejectedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  };

  const getAllPhaseLeads = async (newState = false) => {
    setBoardLoading(true);
    const [followupLead, processingLead, confirmLead, rejectedLead] = await Promise.all([
      // Followup Lead
      getFollowupLeadList({
        ...(newState ? newState : filterlead),
        l_phase: 3,
        id_array: []
      }),
      // Processing Lead
      getFollowupLeadList({
        ...(newState ? newState : filterlead),
        l_phase: 9,
        id_array: []
      }),
      // confirmLead
      getFollowupLeadList({
        ...(newState ? newState : filterlead),
        l_phase: 4,
        id_array: []
      }),
      // rejectedLead
      getFollowupLeadList({
        ...(newState ? newState : filterlead),
        l_phase: 8,
        id_array: []
      })
    ]);
    setBoardLoading(false);

    if (followupLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, followupLead, "followupLead"));
    } else {
      setNewLan((prevState) => prevState);
    }
    if (processingLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, processingLead, "processingLead"));
    } else {
      setNewLan((prevState) => prevState);
    }

    if (confirmLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, confirmLead, "confirmLead"));
    } else {
      setNewLan((prevState) => prevState);
    }

    if (rejectedLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, rejectedLead, "rejectedLead"));
    } else {
      setNewLan((prevState) => prevState);
    }
  };

  const getFilterLeadData = async () => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      followupLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      processingLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      confirmLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      rejectedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    if (filterlead.lead_status != -1) {
      // go for Specific lead Status
      await handleCustomLaneScroll(filterlead.lead_status, true);
    } else {
      // get All Lead
      await getAllPhaseLeads();
    }
  };

  const exportFilteredLead = async (event, done) => {
    setLoading(true);

    setIsLoading(true);
    const resp = await getNewLeadDataForExport({
      ...filterlead,
      type: 1
    });
    setIsLoading(false);

    if (resp.status == 1) {
      // return resp.data;
      downloadCSV(resp.data);
    } else {
      const notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
    setLoading(false);
  };

  const downloadCSV = (data) => {
    const csvContent =
      `${expo_columns?.map((column) => column.label).join(",")}\n` +
      `${data
        ?.map((row) =>
          expo_columns
            ?.map((column) => {
              // Convert value to string
              // const value = (row[column.key] || "").toString();
              let value =
                row[column.key] == undefined ||
                  row[column.key] === null ||
                  row[column.key] === "null"
                  ? ""
                  : row[column.key].toString();

              // Special handling for the Followup column
              if (column.key == "follow_ups") {
                // Replace comma with newline for wrap effect
                value = value.replace(/, /g, "\r\n").trim();
              }
              return `"${value.replace(/"/g, '""')}"`; // Escape double quotes and enclose in quotes
            })
            .join(",")
        )
        .join("\n")}`;

    // Create Blob from CSV content
    // const blob = new Blob([csvContent], { type: "text/csv" });
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    // Create URL for the Blob
    const blobUrl = window.URL.createObjectURL(blob);

    // Create anchor element
    const link = document.createElement("a");
    link.setAttribute("href", blobUrl);
    link.setAttribute("download", "LeadList.csv");

    // Append anchor element to the body and trigger click event
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  };

  const resetSearchForm = async (newState) => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      followupLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      processingLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      confirmLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      rejectedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    await getAllPhaseLeads(newState);
  };

  const updateAPIDataToState = (prevState, newResponse, lead_key) => {
    const { leadList } = newResponse.data;
    const { counter } = newResponse.data;
    return {
      ...prevState,
      "allLeadList": [...prevState["allLeadList"], ...setDataInCard(leadList)],
      "allLeadIds": [
        ...prevState["allLeadIds"],
        ...leadList?.map((lead) => {
          return lead?.lead_id;
        })
      ],
      [lead_key]: {
        ...prevState[lead_key],
        counter: counter,
        // leadList: [...prevState[lead_key].leadList, ...setDataInCard(leadList)],
        id_array: [...prevState[lead_key].id_array, ...leadList?.map((lead) => lead.lead_id)],
        is_no_more: leadList.length < 20 ? true : false
      }
    };
  };

  const setDataInCard = (list) => {
    return list.map((e, key) => {
      return {
        id: e.lead_id,
        l_type: e.l_type,
        taskTitle: e.name,
        referenceBy: e.reference_by != null ? e.reference_by : "No Ref",
        createdDate: moment(e.created_at).format("DD-MM-YYYY hh:mm A"),
        updatedDate: moment(e.updated_at).format("DD-MM-YYYY hh:mm A"),
        body: e.name,
        contactNo: e.l_contact_no,
        taskCreatedPerson: e.createdBy,
        metadata: { id: e.lead_id },
        person: e.allocatedTo,
        phase: e.l_phase,
        tags: {
          cardId: e.lead_id,
          priority_Id: e.l_type,
          attendance_status: e.attendance_status,
          title:
            e.l_type == 0
              ? "Other"
              : e.l_type == 1
                ? e.attendance_status == 0
                  ? "Visitor Present"
                  : "Visitor Absent"
                : e.l_type == 2
                  ? "Member Renewal"
                  : e.l_type == 3
                    ? "Confirm Member"
                    : ""
        },
        expireDate: e.l_type == 2 && e.Due_date,
        chepter_name: e.chepter_name,
        lastElement: key == list.length - 1 ? true : false
      };
    });
  };

  const handleCustomLaneScroll = async (laneId, isCallFromSearch = false) => {
    let lead_key =
      laneId == 3
        ? "followupLead"
        : laneId == 9
          ? "processingLead"
          : laneId == 4
            ? "confirmLead"
            : laneId == 8
              ? "rejectedLead"
              : "";

    if (isCallFromSearch || newLan[lead_key].is_no_more != true) {
      if (loadingMoreData != laneId) {
        setLoadingMoreData(laneId);
        let resp = await getFollowupLeadList({
          ...filterlead,
          l_phase: laneId,
          id_array: isCallFromSearch ? [] : newLan["allLeadIds"]
        });

        if (resp.status == 1) {
          let newDataList = resp.data.leadList;
          let counter = resp.data.counter;
          setNewLan((prevState) => ({
            ...prevState,

            "allLeadList": [...prevState["allLeadList"], ...setDataInCard(newDataList)],

            "allLeadIds": [
              ...prevState["allLeadIds"],
              ...newDataList?.map((lead) => {
                return lead?.lead_id;
              })
            ],

            [lead_key]: {
              ...prevState[lead_key],
              // leadList: [
              //   ...prevState[lead_key].leadList,
              //   ...setDataInCard(newDataList),
              // ],
              counter: counter,
              id_array: [
                ...prevState[lead_key].id_array,
                ...newDataList?.map((lead) => lead.lead_id)
              ],
              is_no_more: newDataList.length < 20 ? true : false
            }
          }));
          setLoadingMoreData(-1);
        } else {
          setNewLan((prevState) => prevState);
          setLoadingMoreData(-1);
        }
      }
      setLoadingMoreData(-1);
    }
    setLoadingMoreData(-1);
  };
  useEffect(async () => {
    allocatelist?.map((option) => {
      filterOption.push({ value: option.u_id, label: option.name });
    });
  }, [allocatelist]);

  const getallocatelistbyid = async () => {
    if (loginUser.u_type == 2) {
      setallocatelist(await fetchallocatelistbyid(loginUser.p_user_id, loginUser.u_type));
    } else {
      setallocatelist(await fetchallocatelistbyid(loginUser.u_id, loginUser.u_type));
    }
  };

  const onChangeFunction = (e) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const getLeadByLeadId = async (l_id) => {
    let res = await getLeadByLid(l_id);
    let arr = [];
    if (res.insuranceType != "") {
      arr = res.insuranceType.split(",");
    }
    setformdata({ ...res, insuranceType: arr });
  };
  const submitformdata = async () => {
    setIsLoading(true);
    let fdata = new FormData();
    // Object.keys(formdata)?.map((key) => {
    //   fdata.append(key, key == "insuranceType" ? formdata[key].join(",") : formdata[key]);
    // });

    Object.keys(formdata)?.map((key) => {
      if (key === "l_payment_photo") {
        // Append multiple payment photos
        if (Array.isArray(formdata[key]) && formdata[key].length > 0) {
          formdata[key].forEach((file, index) => {
            fdata.append(`l_payment_photo`, file);
          });
        }
      } else {
        fdata.append(key, key == "insuranceType" ? formdata[key].join(",") : formdata[key]);
      }
    });

    if (
      formdata.l_allocated_to == undefined ||
      formdata.l_phase == undefined ||
      formdata.name == undefined ||
      formdata.name == "" ||
      formdata.l_business_name == undefined ||
      formdata.l_business_name == "" ||
      formdata.l_contact_no == undefined ||
      formdata.l_contact_no == "" ||
      formdata.l_business_category == undefined ||
      formdata.l_business_category == "" ||
      formdata.date == undefined ||
      formdata.date == "" ||
      formdata.l_reference_1 == undefined ||
      formdata.l_reference_1 == "" ||
      formdata.l_reference_2 == undefined ||
      formdata.l_reference_2 == ""
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
      setIsLoading(false);
    } else {
      let resp;
      if (step == 1) {
        if (loginUser.u_id == formdata?.u_allocated && loginUser.u_type == 1) {
          fdata.append("p_u_id", loginUser?.p_user_id);
        } else if (loginUser.u_type == 2 || loginUser.u_type == 1) {
          fdata.append("p_u_id", loginUser?.p_user_id);
        } else {
          fdata.append("p_u_id", loginUser?.u_id);
        }
        // if (loginUser.u_type != 0) {
        //   fdata.append("p_u_id", loginUser?.p_user_id);
        // } else {
        //   fdata.append("p_u_id", loginUser?.u_id);
        // }
        resp = await insertLead(fdata);
      } else if (step == 2) {
        fdata.append("u_id", loginUser?.u_id);
        fdata.append("edit_from_panel", 0);
        // updateLeadMemberForm()
        // resp = await updateleaddetails(fdata);
        resp = await updateLeadMemberForm(fdata);
      }
      if (resp.status == 1) {
        setStep(0);
        setActiveTab(1);
        setformdata({ l_created_by: loginUser.u_id, l_type: 0 });

        // Followup Lead API CALL
        setNewLan(initNewLan);
        await getAllPhaseLeads();
      }
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      setIsLoading(false);
    }
  };

  const submitfollowup = async () => {
    setIsLoading(true);
    const resp = await insertFollowUp(JSON.stringify(followUpData));
    setIsLoading(false);
    if (resp.status == 1) {
      setFollowUpModal(false);
      setFollowUpData({ u_id: loginUser.u_id });
      setLeadHistory(await featchleadhistory(myModal.lead_id));
    }
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const submitleadtransfer = async () => {
    setIsLoading(true);
    const resp = await leadTransferTO(JSON.stringify(leadtransData));
    setIsLoading(false);
    if (resp.status == 1) {
      setLeadTransModal(false);
      setLeadTransData({ u_id: loginUser.u_id });
      setLeadHistory(await featchleadhistory(myModal.lead_id));
      // Followup Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
    }
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const submitleadrejectreason = async () => {
    if (
      rejectReasonData.l_r_reason_id == 0 ||
      rejectReasonData.l_r_reason_id == "" ||
      rejectReasonData.l_r_reason_id == null ||
      rejectReasonData.l_r_reason_id == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please enter all required fields to submit"
      });
      notify();
    } else {
      setIsLoading(true);

      let resp = await insertMemberLeadRejectReason(JSON.stringify(rejectReasonData));
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        let lfdata = new FormData();
        lfdata.append("lead_id", rejectReasonData.cardId);
        lfdata.append("l_phase", rejectReasonData.targetLaneId);
        lfdata.append("u_id", loginUser.u_id);
        lfdata.append("from_l_phase", rejectReasonData.sourceLaneId);

        setIsLoading(true);

        const resp = await updateleadstatus(lfdata);
        setIsLoading(false);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setrejectmemberModal(false);
          setLeadStatusChangeModal(false);
          setRejectReasonData({
            l_r_reason_id: 0
          });
          // Visitor / Inquiry Lead API CALL
          setNewLan(initNewLan);
          await getAllPhaseLeads();
        }
      }
    }
  };

  const leadStatusChange = async (cardId, targetLaneId, sourceLaneId) => {
    let resp = await featchleadhistory(cardId);
    const lead = resp?.leaddetails;

    // Prevent same-lane movement
    if (targetLaneId === sourceLaneId) return;

    // ✅ Rejected status handling
    if (
      targetLaneId == 8 &&
      (loginUser.u_type == 0 ||
        loginUser.u_type == 1 ||
        (loginUser.u_type == 2 && loginUser.management_p == 1))
    ) {
      setRejectReasonData({
        ...rejectReasonData,
        ...lead,
        cardId: cardId,
        targetLaneId: targetLaneId,
        sourceLaneId: sourceLaneId
      });
      setrejectmemberModal(true);

      // Visitor / Inquiry Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
      return;
    }

    let lfdata = new FormData();
    lfdata.append("lead_id", cardId);
    lfdata.append("l_phase", targetLaneId);
    lfdata.append("u_id", loginUser.u_id);
    lfdata.append("from_l_phase", sourceLaneId);

    const updateResp = await updateleadstatus(lfdata);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (updateResp.status == 1) {
      // Followup Lead API CALL
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
    }
  };

  // KanBan Board
  let len = [[], [], [], [], [], [], [], []];
  newleadData?.map((e, key) => {
    let temp = {
      id: e.lead_id,
      l_type: e.l_type,
      taskTitle: e.name,
      referenceBy: e.reference_by != null ? e.reference_by : "No Ref",
      createdDate: moment(e.created_at).format("DD-MM-YYYY hh:mm A"),
      updatedDate: moment(e.updated_at).format("DD-MM-YYYY hh:mm A"),
      body: e.name,
      contactNo: e.l_contact_no,
      taskCreatedPerson: e.createdBy,
      metadata: { id: e.lead_id },
      person: e.allocatedTo,
      phase: e.l_phase,
      tags: {
        cardId: e.lead_id,
        priority_Id: e.l_type,
        attendance_status: e.attendance_status,
        title:
          e.l_type == 0
            ? "Other"
            : e.l_type == 1
              ? e.attendance_status == 0
                ? "Visitor Present"
                : "Visitor Absent"
              : e.l_type == 2
                ? "Member Renewal"
                : e.l_type == 3
                  ? "Confirm Member"
                  : ""
      },
      expireDate: e.l_type == 2 && e.Due_date,
      chepter_name: e.chepter_name
    };
    // In Confirm And  Rejected Lead Status Set to display on 30 Record on it
    if (e.l_phase == 4) {
      len[e.l_phase].push(temp);
    } else if (e.l_phase == 8) {
      len[e.l_phase].push(temp);
    } else {
      len[e.l_phase].push(temp);
    }
  });

  const getLaneClass = (statusId) => {
    if ([8].includes(statusId)) return "taskListColumn rejectedTask";
    if ([4].includes(statusId)) return "taskListColumn finishTask";
    return "taskListColumn openTask";
  };

  const order = [3, 9, 4, 8]; // Followup lead lane order
  const leadList = {
    lanes: statusList
      ?.filter((item) => order.includes(parseInt(item.a_id)))
      .sort((a, b) => order.indexOf(a.a_id) - order.indexOf(b.a_id))
      .map((status) => {
        const cards = newLan.allLeadList.filter((item) => item.phase === status.a_id);
        const counter =
          status.a_id == 3
            ? newLan.followupLead.counter
            : status.a_id == 9
              ? newLan.processingLead.counter
              : status.a_id == 4
                ? newLan.confirmLead.counter
                : newLan.rejectedLead.counter;

        return {
          id: String(status.a_id),
          title: status.name,
          description: status.description,
          className: getLaneClass(status.a_id), // optional
          cards,
          label: String(counter),
          currentPage: 1,
          style: {
            position: "relative",
            height: `${counter > 0 ? "calc(100vh - 150px)" : ""}`,
            overflowY: "auto"
          }
        };
      })
  };

  const CustomCard = ({
    onClick,
    taskTitle,
    body,
    contactNo,
    createdDate,
    updatedDate,
    subTitle,
    taskCreatedPerson,
    tags,
    showDeleteButton,
    onDelete,
    person,
    phase,
    referenceBy,
    l_type,
    id,
    expireDate,
    chepter_name,
    lastElement
  }) => {
    const clickDelete = (e) => {
      onDelete();
      e.stopPropagation();
    };

    const handleRightClick = (e) => { };

    return (
      <>
        <div id={id} phase={phase} className="myCard" style={{ position: "relative" }}>
          <div className="taskCard" style={{ position: "relative" }}>
            <div>
              <header
                className="taskHeader"
                style={{ paddingBottom: "8px" }}
                onClick={() => {
                  setLeadStatusChangeData({
                    ...leadStatusChangeData,
                    lead_id: id,
                    from_l_phase: phase
                  });
                  setLeadStatusChangeModal(true);
                  // setDvisible({ mval: true, id: id });
                }}
              >
                <div className="TaskTitle">{taskTitle}</div>
                <a
                  className=""
                  style={{ position: "absolute", right: "0px", zIndex: "0" }}
                  onClick={() => {
                    setLeadStatusChangeData({
                      ...leadStatusChangeData,
                      lead_id: id,

                      from_l_phase: phase
                    });
                    setLeadStatusChangeModal(true);
                    // setDvisible({ mval: true, id: id });
                  }}
                >
                  <Tooltip title="Change Lead Status" style={{ padding: 0, margin: 0 }}>
                    <IconButton>
                      <ChangeCircle color="success" style={{ height: "20px", width: "20px" }} />
                    </IconButton>
                  </Tooltip>
                </a>
                {showDeleteButton && <div onClick={clickDelete} />}
              </header>
              <div className="taskBody" onContextMenu={handleRightClick} onClick={onClick}>
                {/* <div>{subTitle}</div> */}
                <p>
                  <b>Name : </b> {taskTitle}
                </p>
                <p>
                  <b>Contact : </b> {contactNo}
                </p>
                {l_type != 0 && (
                  <p>
                    <b>Chapter : </b> {chepter_name}
                  </p>
                )}
                {l_type == 2 && (
                  <p>
                    <b>Membership Expire : </b> {expireDate}
                  </p>
                )}
                <p>
                  {l_type != 0 && referenceBy != "null" && (
                    <>
                      <b>Ref : </b> {referenceBy}
                    </>
                  )}
                </p>
              </div>
              <div className="taskUserDetail">
                <div className="taskCreatedName">
                  <b>Assign To : {person}</b>
                </div>
                {
                  (createdDate != updatedDate) &&
                  (<div className="taskDate">
                    <p>
                      <b>Last update :</b> <span style={{ background: "#d4edda", color: "#155724", borderRadius: "5px" }}>{updatedDate}</span>
                    </p>
                  </div>)
                }
                <div className="taskDate">
                  <p>
                    <b>Created Date :</b> {createdDate}
                  </p>
                </div>
              </div>
            </div>
            <div className="taskFooter">
              <div>
                <p style={{ fontSize: "15px", fontWeight: "bold" }}>{taskCreatedPerson}</p>
              </div>
              <div>
                <a
                  key={tags.title}
                  {...tags}
                  className="taskPriority"
                  attendance_status={tags.attendance_status}
                >
                  {tags.title}
                </a>
              </div>
            </div>
          </div>
        </div>

        {loadingMoreData == phase && lastElement ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CircularProgress color="primary" fourColor variant="indeterminate" />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const cancelModal = () => {
    setMyModal({ mval: false, lead_id: 0, l_phase: 1 });
    setFollowUpModal(false);
    setLeadTransModal(false);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange = (panel) => {
    setExpanded(expanded == panel ? -1 : panel);
  };

  const expo_columns = [
    { label: "No", key: "lead_id" },
    { label: "Lead Date", key: "date" },
    { label: "Type", key: "lead_type" },
    { label: "Name", key: "name" },
    { label: "Followup", key: "follow_ups" },
    { label: "DOB", key: "dob" },
    { label: "Contact No", key: "l_contact_no" },
    { label: "Alternate Contact No", key: "alternate_contact_number" },
    { label: "Insurance", key: "new_insurance" },
    { label: "aadhaar Card Link", key: "aadhaarFilePath" },
    { label: "FaceBook Id", key: "facebook_url" },
    { label: "Instagram Id", key: "instagram_url" },
    { label: "Business Name", key: "l_business_name" },
    { label: "Business Category", key: "l_business_category" },
    { label: "Business Description", key: "l_business_description" },
    { label: "GST Number", key: "gst_no" },
    { label: "Email Id", key: "l_email" },
    { label: "Other Group", key: "other_group_name" },
    { label: "Office Address", key: "l_address" },
    { label: "Home Address", key: "l_h_address" },
    { label: "Payment Date", key: "payment_date" },
    { label: "Payment Mode", key: "new_payment_mode" },
    { label: "Professional Photo", key: "professionalPhotoPath" },
    { label: "Product Photo", key: "productFilePath" },
    { label: "Reference 1", key: "l_reference_1" },
    { label: "Reference 2", key: "l_reference_2" },
    { label: "Payment Screenshot", key: "paymentScreenshotPath" },
    { label: "Payment Note", key: "note" },
    { label: "Attendance Status", key: "new_Attendance_Status" },
    { label: "Created By", key: "createdBy" },
    { label: "Allocated To", key: "allocatedTo" },
    { label: "Phase", key: "lead_phase" },
    { label: "Reference By", key: "reference_by" },
    { label: "Renewal Reject Reason", key: "lead_reject_reason" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.lead_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.date
    },
    {
      name: "Type",
      wrap: true,
      selector: (row) =>
        row.l_type == 0
          ? "Other"
          : row.l_type == 1
            ? row.attendance_status == 0
              ? "Visitor Present"
              : "Visitor Absent"
            : row.l_type == 2
              ? "Member Renewal"
              : row.l_type == 3
                ? "Confirm Member"
                : ""
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row.name
    },

    {
      name: "Contact No",
      wrap: true,
      selector: (row) => row.l_contact_no
    },
    {
      name: "Created By",
      wrap: true,
      selector: (row) => row.createdBy
    },
    {
      name: "Allocated To",
      wrap: true,
      selector: (row) => row.allocatedTo
    },
    {
      name: "Phase",
      wrap: true,
      selector: (row) => (
        <>
          {statusList &&
            statusList?.map((k) => {
              if (k.value == row.l_phase) {
                return k.label;
              }
            })}
        </>
      ),
      sortable: true
    },
    {
      name: "Refrence By",
      wrap: true,
      selector: (row) => row.reference_by
    }
  ];

  const allowedFileTypes = [
    // Images
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    // PDFs
    "application/pdf",
    // Microsoft Word Documents
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
  ];

  const allowFileImageTypes = [
    // Images
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif"
  ];

  const handleFileChange = (event, inputName) => {
    const files = inputName === "l_payment_photo" ? event.target.files : [event.target.files[0]];

    if (inputName === "l_payment_photo") {
      // Handle multiple files for payment photo
      const validFiles = [];
      const invalidFiles = [];

      Array.from(files).forEach((file) => {
        if (allowedFileTypes.includes(file.type)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        // setErrors({
        //   ...errors,
        //   [inputName]: `Invalid file type for: ${invalidFiles.join(", ")}. Upload File Must be an Image`
        // });
      } else {
        const existingFiles = Array.isArray(formdata[inputName]) ? formdata[inputName] : [];
        // Filter out duplicates
        const newFiles = validFiles.filter((newFile) => {
          return !existingFiles.some(
            (existingFile) =>
              existingFile.name === newFile.name && existingFile.size === newFile.size
          );
        });

        // If file already exists, replace it
        const updatedFiles = existingFiles.map((existingFile) => {
          const replacement = validFiles.find(
            (newFile) => newFile.name === existingFile.name && newFile.size === existingFile.size
          );
          return replacement || existingFile;
        });

        // Add completely new files
        const finalFiles = [...updatedFiles, ...newFiles];

        setformdata({ ...formdata, [inputName]: finalFiles });
        // setErrors({ ...errors, [inputName]: "" });
      }
    } else {
      const file = files[0];
      if (file) {
        if (file.size <= 11 * 1024 * 1024) {
          // 2MB in bytes
          if (
            (inputName == "aadhaar" ? allowedFileTypes : allowFileImageTypes).includes(file.type)
          ) {
            // setSelectedFile(file);
            setformdata({ ...formdata, [inputName]: file });
            // setErrors({ ...errors, [inputName]: "" });
            // setErrorMessage('');
          } else {
            // setErrors({
            //   ...errors,
            //   [inputName]: `${
            //     inputName == "aadhaar"
            //       ? "Upload File Must Be PDF, Image or Doc"
            //       : "Upload File Must be an Image"
            //   }  `,
            // });
            // setSelectedFile(null);
            // setErrorMessage('Invalid file type. Please upload an image, PDF, or DOC file.');
          }
        } else {
          // setErrors({
          //   ...errors,
          //   [inputName]: "File Sizes Greater Than 2MB Are Not Supported",
          // });
          // setSelectedFile(null);
          // setErrorMessage('File size exceeds 2MB limit.');
        }
      }
    }
  };

  useEffect(async () => {
    await getallocatelistbyid();
    setRejectReasonlist(await getLeadRejectReason());
  }, []);

  useEffect(async () => {
    await handleGetAttributeList();
    if (location.state?.lead_status != null && location.state?.lead_status != -1) {
      await getFilterLeadData();
    } else {
      getAllPhaseLeads();
    }
    getallcitylist();
  }, []);

  useEffect(() => {
    let filtered = allocatelist?.filter((option) => option.city_id === filterlead.filterCity);

    let selectedUser = null;
    if (loginUser?.u_type == 0 || (loginUser?.u_type == 0 && loginUser?.is_subadmin == 1)) {
      selectedUser = filtered.find((user) => user?.u_type == 1);
    } else {
      selectedUser = filtered.find((user) => user?.u_id == filterlead.u_id);
    }

    filtered = filtered.map((option) => ({
      value: option.u_id,
      label: option.name
    }));

    setFilterOption(filtered || []);

    if (selectedUser) {
      setfilterlead((prev) => ({
        ...prev,
        filteruser: selectedUser?.u_id
      }));
    } else {
      setfilterlead((prev) => ({
        ...prev,
        filteruser: 0
      }));
    }
  }, [filterlead.filterCity, allocatelist]);

  // Directional drag rotation: tilt left when moving left, right when moving right
  useEffect(() => {
    let dragStartX = null;

    const getClientX = (e) => {
      if (e.clientX !== undefined) return e.clientX;
      if (e.touches && e.touches[0]) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
      return null;
    };

    const onDown = (e) => {
      const target = e.target.closest(
        ".smooth-dnd-draggable-wrapper, .react-trello-card, .myCard, .taskCard"
      );
      if (target) {
        const x = getClientX(e);
        if (x !== null) dragStartX = x;
      }
    };

    const onMove = (e) => {
      const ghost = document.querySelector(".smooth-dnd-ghost");
      if (!ghost || dragStartX === null) return;
      const currentX = getClientX(e);
      if (currentX === null) return;
      const deltaX = currentX - dragStartX;
      const cardEl = ghost.firstElementChild;
      if (!cardEl) return;
      if (deltaX < -5) {
        cardEl.style.transform = "rotate(-3deg)";
      } else if (deltaX > 5) {
        cardEl.style.transform = "rotate(3deg)";
      } else {
        cardEl.style.transform = "rotate(0deg)";
      }
      cardEl.style.transition = "transform 0.12s ease";
    };

    const onUp = () => {
      dragStartX = null;
      const ghost = document.querySelector(".smooth-dnd-ghost");
      if (ghost && ghost.firstElementChild) {
        ghost.firstElementChild.style.transform = "";
      }
    };

    document.addEventListener("mousedown", onDown, true);
    document.addEventListener("touchstart", onDown, { passive: true, capture: true });
    document.addEventListener("mousemove", onMove, true);
    document.addEventListener("touchmove", onMove, { passive: false, capture: true });
    document.addEventListener("mouseup", onUp, true);
    document.addEventListener("touchend", onUp, true);

    return () => {
      document.removeEventListener("mousedown", onDown, true);
      document.removeEventListener("touchstart", onDown, true);
      document.removeEventListener("mousemove", onMove, true);
      document.removeEventListener("touchmove", onMove, true);
      document.removeEventListener("mouseup", onUp, true);
      document.removeEventListener("touchend", onUp, true);
    };
  }, []);

  return (
    <>
      <Modal
        style={{ overflow: "scroll" }}
        open={myModal.mval}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadDetailsModelStyle}>
          <Typography
            id="modal-modal-title"
            variant="div"
            component="div"
            style={{
              margin: "10px",
              textAlign: "center",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div style={{ width: "100%" }}>
              <Tooltip
                title="Edit Lead"
                onClick={async () => {
                  await getLeadByLeadId(myModal.lead_id);
                  await cancelModal();
                  await setStep(2);
                }}
              >
                <IconButton>
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>
              {[3, 9].includes(leadHistory?.leaddetails?.l_phase) && (
                <Tooltip
                  title="Add Followup"
                  onClick={async () => {
                    // await setMyModal({ mval: false, lead_id: 0 });
                    await setFollowUpData({
                      ...followUpData,
                      lead_id: myModal.lead_id
                    });
                    await setFollowUpModal(true);
                  }}
                >
                  <IconButton>
                    <SendSharp color="info" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip
                title="Transfer Lead"
                onClick={async () => {
                  await setLeadTransData({
                    ...leadtransData,
                    lead_id: myModal.lead_id
                  });
                  await setLeadTransModal(true);
                }}
              >
                <IconButton>
                  <PersonAddAltSharp color="success" />
                </IconButton>
              </Tooltip>
            </div>

            <div>
              <Tooltip
                title="Close"
                onClick={async () => {
                  await cancelModal();
                  setValue("1");
                }}
              >
                <IconButton>
                  <Close color="blank" />
                </IconButton>
              </Tooltip>
            </div>
          </Typography>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example" centered>
                <Tab
                  icon={<LeaderboardSharp />}
                  iconPosition="end"
                  label="Lead Details"
                  value="1"
                />
                <Tab icon={<ThumbUpAlt />} iconPosition="end" label="Follow Up History" value="2" />
                <Tab icon={<AutoGraphSharp />} iconPosition="end" label="Activity Log" value="3" />
              </TabList>
            </Box>
            <div
              style={{
                maxHeight: "500px",
                height: "500px",
                overflowY: "scroll"
              }}
            >
              <TabPanel value="1">
                <>
                  <Grid container spacing={2}>
                    <Grid xs={8} item>
                      {/* Personal Details Card */}
                      <Card style={{ border: "1px solid #abababb5" }}>
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Personal Information
                          </h3>
                          <Grid container spacing={0}>
                            {!IsNotValue.includes(leadHistory?.leaddetails?.name) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Name </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.name || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.gender) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Gender </h4>
                                  <p className="word-break-all">
                                    {gender[leadHistory?.leaddetails?.gender]?.label || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.dob) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>DOB </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.dob || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_contact_no) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Contact No </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_contact_no || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(
                              leadHistory?.leaddetails?.alternate_contact_number
                            ) && (
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Alternate Contact No </h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.alternate_contact_number || "-"}
                                    </p>
                                  </div>
                                </Grid>
                              )}
                            {leadHistory?.leaddetails?.insuranceType !== "-1" && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Insurance</h4>
                                  <p className="word-break-all">
                                    {/* {leadHistory?.leaddetails?.insuranceType == 1
                                    ? "Health Insurance"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      2
                                    ? "Life Insurance"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      3
                                    ? "Term Insurance"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      4
                                    ? "None"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      0
                                    ? `Other - ${leadHistory?.leaddetails?.otherInsurance}`
                                    : "-"} */}

                                    {leadHistory?.leaddetails?.insuranceType
                                      ?.split(",")
                                      ?.map((type, index) => (
                                        <span key={index}>
                                          {type == 1
                                            ? "Health Insurance"
                                            : type == 2
                                              ? "Life Insurance"
                                              : type == 3
                                                ? "Term Insurance"
                                                : type == 4
                                                  ? "None"
                                                  : type == 0
                                                    ? `Other - ${leadHistory?.leaddetails?.otherInsurance}`
                                                    : "-"}
                                          {index !==
                                            leadHistory?.leaddetails?.insuranceType?.split(",")
                                              .length -
                                            1 && ", "}
                                        </span>
                                      ))}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.aadhaar) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={9} item>
                                      <h4 style={{ color: "#838383" }}>Aadhaar Card</h4>
                                      <p className="word-break-all">
                                        {leadHistory?.leaddetails?.aadhaar || "-"}
                                      </p>
                                    </Grid>
                                    {leadHistory?.leaddetails?.aadhaar && (
                                      <Grid xs={3} item>
                                        <div
                                          className="d-flex"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "end",
                                            justifyContent: "space-between"
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer"
                                            href="#"
                                            onClick={() => {
                                              saveAs(
                                                Routes.API_HOSTNAME +
                                                "images/leadMemberAadhaar/" +
                                                leadHistory?.leaddetails?.aadhaar,
                                                leadHistory?.leaddetails?.aadhaar
                                              );
                                            }}
                                          >
                                            Download
                                          </a>
                                          <a
                                            className="cursor-pointer"
                                            href={
                                              Routes.API_HOSTNAME +
                                              "images/leadMemberAadhaar/" +
                                              leadHistory?.leaddetails?.aadhaar
                                            }
                                            target="_blank"
                                          >
                                            Open
                                          </a>
                                        </div>
                                      </Grid>
                                    )}
                                  </Grid>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.facebook_url) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Facebook ID</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.facebook_url || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.instagram_url) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Instagram ID</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.instagram_url || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                      </Card>

                      {/* Business Details Card */}
                      <Card
                        style={{
                          border: "1px solid #abababb5",
                          marginTop: "15px"
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Business Information
                          </h3>
                          <Grid container spacing={0}>
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_business_name) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Business Name</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_business_name || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(
                              leadHistory?.leaddetails?.l_business_category
                            ) && (
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Business Category</h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.l_business_category || "-"}
                                    </p>
                                  </div>
                                </Grid>
                              )}
                            {!IsNotValue.includes(
                              leadHistory?.leaddetails?.l_business_description
                            ) && (
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Business Description</h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.l_business_description || "-"}
                                    </p>
                                  </div>
                                </Grid>
                              )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.gst_no) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>GST No </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.gst_no || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_email) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Email ID</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_email || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.other_group_name) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Other Group Name</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.other_group_name || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_address) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Office Address</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_address || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_h_address) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Home Address</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_h_address || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.payment_date) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Payment Date</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.payment_date || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {leadHistory?.leaddetails?.payment_mode !== undefined &&
                              leadHistory?.leaddetails?.payment_mode !== null &&
                              leadHistory?.leaddetails?.payment_mode !== "" && (
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Payment Mode</h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.payment_mode == 0
                                        ? "Cash"
                                        : leadHistory?.leaddetails?.payment_mode == 1
                                          ? "Transfer"
                                          : leadHistory?.leaddetails?.payment_mode == 2
                                            ? "Cheque"
                                            : "-"}
                                    </p>
                                  </div>
                                </Grid>
                              )}
                            {!IsNotValue.includes(
                              leadHistory?.leaddetails?.l_professional_photo
                            ) && (
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <Grid container spacing={0}>
                                      <Grid xs={9} item>
                                        <h4 style={{ color: "#838383" }}>Professional Photo</h4>
                                        <p className="word-break-all">
                                          {leadHistory?.leaddetails?.l_professional_photo || "-"}
                                        </p>
                                      </Grid>
                                      {leadHistory?.leaddetails?.l_professional_photo && (
                                        <Grid xs={3} item>
                                          <div
                                            className="d-flex"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "end",
                                              justifyContent: "space-between"
                                            }}
                                          >
                                            <a
                                              className="cursor-pointer"
                                              href="#"
                                              onClick={() => {
                                                saveAs(
                                                  Routes.API_HOSTNAME +
                                                  "images/leadMemberProfile/" +
                                                  leadHistory?.leaddetails?.l_professional_photo,
                                                  leadHistory?.leaddetails?.l_professional_photo
                                                );
                                              }}
                                            >
                                              Download
                                            </a>
                                            <a
                                              className="cursor-pointer"
                                              href={
                                                Routes.API_HOSTNAME +
                                                "images/leadMemberProfile/" +
                                                leadHistory?.leaddetails?.l_professional_photo
                                              }
                                              target="_blank"
                                            >
                                              Open
                                            </a>
                                          </div>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </div>
                                </Grid>
                              )}
                            {/* {!IsNotValue.includes(leadHistory?.leaddetails?.l_product_photo) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={9} item>
                                      <h4 style={{ color: "#838383" }}>Product Photo</h4>
                                      <p className="word-break-all">
                                        {leadHistory?.leaddetails?.l_product_photo || "-"}
                                      </p>
                                    </Grid>
                                    {leadHistory?.leaddetails?.l_product_photo && (
                                      <Grid xs={3} item>
                                        <div
                                          className="d-flex"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "end",
                                            justifyContent: "space-between"
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer"
                                            href="#"
                                            onClick={() => {
                                              saveAs(
                                                Routes.API_HOSTNAME +
                                                  "images/leadMemberProduct/" +
                                                  leadHistory?.leaddetails?.l_product_photo,
                                                leadHistory?.leaddetails?.l_product_photo
                                              );
                                            }}
                                          >
                                            Download
                                          </a>
                                          <a
                                            className="cursor-pointer"
                                            href={
                                              Routes.API_HOSTNAME +
                                              "images/leadMemberProduct/" +
                                              leadHistory?.leaddetails?.l_product_photo
                                            }
                                            target="_blank"
                                          >
                                            Open
                                          </a>
                                        </div>
                                      </Grid>
                                    )}
                                  </Grid>
                                </div>
                              </Grid>
                            )} */}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_payment_photo) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={9} item>
                                      <h4 style={{ color: "#838383" }}>
                                        Payment Screenshot / Cheque Photo{" "}
                                      </h4>
                                    </Grid>

                                    {Array.isArray(leadHistory?.leaddetails?.l_payment_photo) &&
                                      leadHistory?.leaddetails?.l_payment_photo.length > 0 &&
                                      leadHistory?.leaddetails?.l_payment_photo.map(
                                        (photo, index) => (
                                          <Grid xs={12} item key={index}>
                                            <div
                                              className="d-flex"
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                borderBottom:
                                                  index !==
                                                    leadHistory?.leaddetails?.l_payment_photo.length -
                                                    1
                                                    ? "1px solid #abababb5"
                                                    : "none",
                                                paddingBottom: "5px",
                                                marginBottom: "10px"
                                              }}
                                            >
                                              <p className="word-break-all">{photo}</p>
                                              <div>
                                                <a
                                                  className="cursor-pointer"
                                                  href="#"
                                                  onClick={() => {
                                                    saveAs(
                                                      Routes.API_HOSTNAME +
                                                      "images/leadMemberPayment/" +
                                                      photo,
                                                      photo
                                                    );
                                                  }}
                                                >
                                                  Download
                                                </a>
                                                <br />
                                                <a
                                                  className="cursor-pointer"
                                                  href={
                                                    Routes.API_HOSTNAME +
                                                    "images/leadMemberPayment/" +
                                                    photo
                                                  }
                                                  target="_blank"
                                                >
                                                  Open
                                                </a>
                                              </div>
                                            </div>
                                          </Grid>
                                        )
                                      )}
                                  </Grid>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_reference_1) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reference 1</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_reference_1 || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_reference_2) && (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reference 2</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_reference_2 || "-"}
                                  </p>
                                </div>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                      </Card>
                    </Grid>

                    {/* Right Side  */}
                    <Grid xs={4} item>
                      <div style={{ position: "sticky", top: "10px" }}>
                        <Card
                          style={{
                            border: "1px solid #abababb5"
                          }}
                        >
                          <div>
                            <h3
                              style={{
                                padding: "15px",
                                background: "#1c4766",
                                color: "#fff"
                              }}
                            >
                              Lead Information
                            </h3>
                            <div>
                              {!IsNotValue.includes(leadHistory?.leaddetails?.date) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Date </h4>
                                  <p className="word-break-all">{leadHistory?.leaddetails?.date}</p>
                                </div>
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.l_type) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Lead Type </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_type == 0
                                      ? "Other"
                                      : leadHistory?.leaddetails?.l_type == 1
                                        ? "Visitor"
                                        : leadHistory?.leaddetails?.l_type == 2
                                          ? "Member Renewal"
                                          : leadHistory?.leaddetails?.l_type == 3
                                            ? "Confirm Member"
                                            : ""}
                                  </p>
                                </div>
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.l_phase) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Lead Status </h4>
                                  <p className="word-break-all">
                                    {statusList?.map((e) => {
                                      if (e.a_id == leadHistory?.leaddetails?.l_phase) {
                                        return e.name;
                                      }
                                    })}
                                  </p>
                                </div>
                              )}
                              {!IsNotValue.includes(
                                leadHistory?.leaddetails?.lead_reject_reason
                              ) && (
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Reject Reason </h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.lead_reject_reason}
                                    </p>
                                  </div>
                                )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.allocatedTo) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Allocated To</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.allocatedTo}
                                  </p>
                                </div>
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.createdBy) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Created By </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.createdBy}
                                  </p>
                                </div>
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.reference_by) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reference By </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.reference_by || "-"}
                                  </p>
                                </div>
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.note) && (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Payment Note </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.note || "-"}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Grid>
                  </Grid>
                </>
              </TabPanel>
              <TabPanel value="2">
                <>
                  {leadHistory?.followupdetails?.map((e, key) => {
                    return (
                      <Accordion
                        style={{
                          boxShadow: "#0000003d 0px 0px 6px 0px",
                          marginBottom: "10px",
                          borderRadius: "11px",
                          border: "1px solid #1c47669c"
                        }}
                        expanded={expanded === key}
                        onChange={() => handleChange(key)}
                      >
                        <AccordionSummary
                          style={{
                            background: "#1c4766",
                            color: "#fff",
                            borderRadius: "10px"
                          }}
                          aria-controls="panel1d-content"
                          id={key}
                        // panel1d-header
                        >
                          <Typography>{e.userName + " ( " + e.date + " )"}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            <p>Next Follow Date : {e.next_f_date}</p>
                            <p>Comment : {e.comment}</p>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </>
              </TabPanel>
              <TabPanel value="3">
                <Timeline position="right">
                  {leadHistory?.activitylog?.map((e) => {
                    return (
                      <TimelineItem>
                        <TimelineOppositeContent
                          color="text.secondary"
                          style={{
                            textAlign: "left",
                            width: "150px",
                            maxWidth: "150px"
                          }}
                        >
                          {e.date}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot color="primary" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent style={{ wordBreak: "break-word" }}>
                          <h4>{e.userName}</h4>
                          <p>{e.l_a_description}</p>
                        </TimelineContent>
                      </TimelineItem>
                    );
                  })}
                </Timeline>
              </TabPanel>
            </div>
          </TabContext>
        </Box>
      </Modal>
      <Modal
        open={followUpModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Follow Up
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Card style={{ padding: "25px", paddingBottom: "25px" }}>
                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            style={{ marginTop: "15px" }}
                          >
                            <DatePicker
                              type="date"
                              name="next_f_date "
                              label="Next FollowUp date"
                              inputFormat="dd/MM/yyyy"
                              value={moment(followUpData.next_f_date, "DD-MM-YYYY")}
                              onChange={(newDate) => {
                                setFollowUpData({
                                  ...followUpData,
                                  next_f_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                });
                              }}
                              renderInput={(params) => <TextField {...params} />}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <LimitedTextField
                            limitKey="lead_followup_comment"
                            rows={4}
                            multiline
                            fullWidth
                            autoComplete="off"
                            label="Comment"
                            name="comment"
                            value={followUpData?.comment}
                            onChange={(e) => {
                              setFollowUpData({
                                ...followUpData,
                                comment: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setFollowUpModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitfollowup}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={leadtransModal}
        // onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Transfer
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                {/* <Card style={{ padding: "25px", paddingBottom: "25px" }}> */}
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Transer To</label>
                        <Select
                          value={
                            allocatelist &&
                            allocatelist
                              ?.map((p) => {
                                if (p.u_id == leadtransData.l_transfer_to) {
                                  return { value: p.u_id, label: p.u_name };
                                }
                              })
                              .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="l_transfer_to"
                          onChange={(e) => {
                            setLeadTransData({
                              ...leadtransData,
                              l_transfer_to: e.value
                            });
                          }}
                          options={
                            allocatelist != null &&
                            allocatelist?.map((p) => {
                              return { value: p.u_id, label: p.u_name };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
                {/* </Card> */}
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setLeadTransModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitleadtransfer}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={rejectmemberModal}
        onClose={() => setrejectmemberModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Reject Reason
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        {/* <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          multiline
                          rows={5}
                          autoComplete="off"
                          type="text"
                          label="Reason"
                          name="member_renewal_reject_reason"
                          value={rejectReasonData?.member_renewal_reject_reason}
                          onChange={(e) => {
                            setRejectReasonData({
                              ...rejectReasonData,
                              member_renewal_reject_reason: e.target.value,
                            });
                          }}
                        /> */}
                        <label style={{ marginBottom: "10px" }}>Select Reject Reason</label>
                        <Select
                          value={
                            rejectReasonlist &&
                            rejectReasonlist
                              ?.map((p) => {
                                if (p.l_r_reason_id == rejectReasonData.l_r_reason_id) {
                                  return { value: p.l_r_reason_id, label: p.lead_reject_reason };
                                }
                              })
                              .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="l_r_reason_id"
                          onChange={(e) => {
                            setRejectReasonData({
                              ...rejectReasonData,
                              l_r_reason_id: e.value
                            });
                          }}
                          options={
                            rejectReasonlist != null &&
                            rejectReasonlist?.map((p) => {
                              return { value: p.l_r_reason_id, label: p.lead_reject_reason };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setrejectmemberModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitleadrejectreason}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Lead Change Modal */}
      <Modal
        open={leadStatusChangeModal}
        onClose={closeLeadStatusChangeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Update Lead Status
          </Typography>
          <div style={{ padding: "10px" }}>
            {statusList?.map((status) => {
              const currentPhase = leadStatusChangeData?.from_l_phase;
              return (
                <div
                  value={status?.a_id}
                  style={{
                    position: "relative",
                    marginBottom: "10px",
                    border:
                      currentPhase == status?.a_id
                        ? "none"
                        : "2px solid #1c4766",
                    padding: "7px 15px",
                    borderRadius: "10px",
                    background:
                      currentPhase == status?.a_id ? "#1c4766" : "#fff",
                    color: currentPhase == status?.a_id ? "#fff" : "#000",
                    cursor: "pointer",
                    WebkitUserSelect: "none", // Optional: Disable text selection on double-click
                    MozUserSelect: "none", // Optional: Disable text selection on double-click
                    msUserSelect: "none", // Optional: Disable text selection on double-click
                    userSelect: "none" // Optional: Disable text selection on double-click
                  }}
                  onClick={async (e) => {
                    const divValue = e.currentTarget.getAttribute("value");
                    await leadStatusChange(
                      leadStatusChangeData.lead_id,
                      divValue,
                      currentPhase
                    );
                  }}
                >
                  <a id="">{status.name}</a>
                  {currentPhase == status?.a_id && (
                    <Check color="#fff" style={{ position: "absolute", right: "10" }} />
                  )}
                </div>
              );
            })}
            <hr />

            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button variant="outlined" onClick={closeLeadStatusChangeModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Page title="Followup Leads | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Followup Leads
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                className="btn btn-export"
                style={{ marginBottom: "15px", marginTop: "0" }}
                variant="contained"
                onClick={exportFilteredLead}
                // disabled={loading}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                {loading ? "Exporting..." : "Export CSV"}
              </Button>
            </div>
          </Stack>
          {step == 2 ? (
            // <>
            //   <Button
            //     onClick={() => {
            //       setStep(0);
            //       setformdata({ l_created_by: loginUser.u_id, l_type: 0 });
            //     }}
            //     style={{ marginBottom: "15px" }}
            //     variant="contained"
            //   >
            //     Back
            //   </Button>
            //   <Card className="p-20">
            //     <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            //       <Tabs
            //         value={activeTab}
            //         variant="fullWidth"
            //         allowScrollButtonsMobile
            //         onChange={
            //           (e, value) => {
            //             // checkValidation(value);
            //             setActiveTab(value);
            //           }
            //           // setMemberDetailData([]),
            //           // setActiveTab(value),
            //           // getMembersDetailReport(value, activeRow.m_id)
            //         }
            //       >
            //         <Tab
            //           className="mb-0 pb-0"
            //           disableRipple
            //           key={1}
            //           value={1}
            //           label="Personal Details"
            //           icon={<Person />}
            //           iconPosition="start"
            //         />
            //         <Tab
            //           className="mb-0 pb-0"
            //           disableRipple
            //           key={2}
            //           value={2}
            //           label="Business Details"
            //           icon={<Business />}
            //           iconPosition="start"
            //         />
            //       </Tabs>
            //     </Box>
            //     <Grid container spacing={2} className="mt-10">
            //       {activeTab == 1 ? (
            //         <>
            //           <Grid item xs={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_name"
            //                 style={{ marginTop: "0px" }}
            //                 fullWidth
            //                 required
            //                 autoComplete="off"
            //                 type="text"
            //                 label="Full Name"
            //                 name="name"
            //                 value={formdata?.name}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LocalizationProvider dateAdapter={AdapterDateFns}>
            //                 <DatePicker
            //                   type="date"
            //                   name="dob"
            //                   label="Date of Birth"
            //                   value={
            //                     formdata?.dob != undefined
            //                       ? moment(formdata.dob, "DD-MM-YYYY")
            //                       : null
            //                   }
            //                   disableFuture
            //                   inputFormat="dd/MM/yyyy"
            //                   onChange={(newDate) => {
            //                     setformdata({
            //                       ...formdata,
            //                       dob: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
            //                     });
            //                   }}
            //                   renderInput={(params) => <TextField {...params} required />}
            //                 />
            //               </LocalizationProvider>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_contact_no"
            //                 fullWidth
            //                 required
            //                 autoComplete="off"
            //                 type="text"
            //                 label="Contact Number"
            //                 name="l_contact_no"
            //                 value={formdata?.l_contact_no}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_alt_contact_no"
            //                 fullWidth
            //                 autoComplete="off"
            //                 type="text"
            //                 label="Alternate Contact Number"
            //                 name="alternate_contact_number"
            //                 value={formdata?.alternate_contact_number}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <FormControl>
            //                 <FormLabel id="demo-error-radios" className="font-bold">
            //                   Please Select Insurance you have
            //                   <span
            //                     aria-hidden="true"
            //                     className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
            //                   >
            //                     *
            //                   </span>
            //                 </FormLabel>
            //                 <FormGroup
            //                   name="insuranceType"
            //                   // value={formdata?.insuranceType}
            //                   // onChange={(e) => {
            //                   //   setformdata({
            //                   //     ...formdata,
            //                   //     insuranceType: e.target.value,
            //                   //     otherInsurance: "",
            //                   //   });
            //                   // }}
            //                 >
            //                   {/* <FormControlLabel
            //                     value="1"
            //                     control={<Radio />}
            //                     label="Health Insurance"
            //                   />
            //                   <FormControlLabel
            //                     value={2}
            //                     control={<Radio />}
            //                     label="Life Insurance"
            //                   />
            //                   <FormControlLabel
            //                     value={3}
            //                     control={<Radio />}
            //                     label="Term Insurance"
            //                   />
            //                   <FormControlLabel
            //                     value={4}
            //                     control={<Radio />}
            //                     label="None"
            //                   />
            //                   <FormControlLabel
            //                     value={0}
            //                     control={<Radio />}
            //                     label="Other"
            //                   /> */}
            //                   <FormControlLabel
            //                     onChange={(e) => handleInsuranceCheckBoxEvent(e)}
            //                     value={1}
            //                     control={
            //                       <Checkbox
            //                         checked={formdata?.insuranceType?.includes("1")}
            //                         name="Health_Insurance"
            //                       />
            //                     }
            //                     label="Health Insurance"
            //                   />
            //                   <FormControlLabel
            //                     onChange={(e) => handleInsuranceCheckBoxEvent(e)}
            //                     value={2}
            //                     control={
            //                       <Checkbox
            //                         name="Life_Insurance"
            //                         checked={formdata?.insuranceType?.includes("2")}
            //                       />
            //                     }
            //                     label="Life Insurance"
            //                   />
            //                   <FormControlLabel
            //                     onChange={(e) => handleInsuranceCheckBoxEvent(e)}
            //                     value={3}
            //                     control={
            //                       <Checkbox
            //                         name="Term_Insurance"
            //                         checked={formdata?.insuranceType?.includes("3")}
            //                       />
            //                     }
            //                     label="Term Insurance"
            //                   />
            //                   <FormControlLabel
            //                     onChange={(e) => handleInsuranceCheckBoxEvent(e)}
            //                     value={4}
            //                     control={
            //                       <Checkbox
            //                         name="None"
            //                         checked={formdata?.insuranceType?.includes("4")}
            //                       />
            //                     }
            //                     label="None"
            //                   />
            //                   <FormControlLabel
            //                     value={0}
            //                     onChange={(e) => handleInsuranceCheckBoxEvent(e)}
            //                     control={
            //                       <Checkbox
            //                         name="Other"
            //                         checked={formdata?.insuranceType?.includes("0")}
            //                       />
            //                     }
            //                     label="Other"
            //                   />

            //                   {formdata?.insuranceType?.includes("0") && (
            //                     <LimitedTextField
            //   limitKey="lead_other_insurance"
            //                       // label="Other Option"
            //                       variant="standard"
            //                       fullWidth
            //                       autoComplete="off"
            //                       autoCorrect="off"
            //                       name="otherInsurance"
            //                       placeholder="Other Insurance"
            //                       value={formdata?.otherInsurance}
            //                       onChange={onChangeFunction}
            //                     />
            //                   )}
            //                 </FormGroup>
            //               </FormControl>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <FormControl variant="standard">
            //                 <FormLabel id="demo-error-radios" className="label-bold">
            //                   Select Aadhaar Card Front & Back Photo{" "}
            //                   <span
            //                     aria-hidden="true"
            //                     className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
            //                   >
            //                     *
            //                   </span>
            //                 </FormLabel>
            //                 <div>
            //                   <label className="file-label" htmlFor="file">
            //                     <Label
            //                       variant="filled"
            //                       color={"primary"}
            //                       className="select-file-label"
            //                     >
            //                       <div className="select-file-label-text">
            //                         Select File
            //                         <AddPhotoAlternate className="select-file-label-icon" />
            //                       </div>
            //                     </Label>
            //                     <input
            //                       id="file"
            //                       type="file"
            //                       hidden
            //                       name="aadhaar"
            //                       accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
            //                       onChange={(e) => {
            //                         handleFileChange(e, "aadhaar");
            //                       }}

            //                       // onBlur={checkValidation}
            //                     />
            //                   </label>
            //                   <div>
            //                     <>
            //                       {formdata?.aadhaar && (
            //                         <div className="upload-file-name">
            //                           {formdata?.aadhaar?.name || formdata?.aadhaar}
            //                         </div>
            //                       )}

            //                       {/* Input Helper */}
            //                       <Label variant={"ghost"} color="error" className="warning-note">
            //                         More Then 10MB of File Are Not Supported
            //                       </Label>

            //                       <Label variant={"ghost"} color="error" className="warning-note">
            //                         Note: PDF, Doc & Images are Only Supported
            //                       </Label>
            //                     </>
            //                   </div>
            //                 </div>
            //               </FormControl>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <TextField
            //                 fullWidth
            //                 type="text"
            //                 label="Enter Facebook ID"
            //                 name="facebook_url"
            //                 value={formdata?.facebook_url}
            //                 onChange={onChangeFunction}
            //                 autoComplete="off"
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <TextField
            //                 fullWidth
            //                 type="text"
            //                 label="Enter Instagram ID"
            //                 name="instagram_url"
            //                 value={formdata?.instagram_url}
            //                 onChange={onChangeFunction}
            //                 autoComplete="off"
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //         </>
            //       ) : (
            //         <>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_business_name"
            //                 fullWidth
            //                 autoComplete="off"
            //                 autoCorrect="off"
            //                 type="text"
            //                 required
            //                 label="Company Name"
            //                 name="l_business_name"
            //                 value={formdata?.l_business_name}
            //                 onChange={onChangeFunction}
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_business_category"
            //                 fullWidth
            //                 required
            //                 autoComplete="off"
            //                 autoCorrect="off"
            //                 type="text"
            //                 label="Business Category"
            //                 name="l_business_category"
            //                 value={formdata?.l_business_category}
            //                 onChange={onChangeFunction}
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_business_description"
            //                 fullWidth
            //                 autoComplete="off"
            //                 autoCorrect="off"
            //                 type="text"
            //                 label="Business Description"
            //                 name="l_business_description"
            //                 value={formdata?.l_business_description}
            //                 onChange={onChangeFunction}
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_gst_no"
            //                 fullWidth
            //                 autoComplete="off"
            //                 type="text"
            //                 label="GST No"
            //                 name="gst_no"
            //                 value={formdata?.gst_no}
            //                 onChange={onChangeFunction}
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_email"
            //                 fullWidth
            //                 autoComplete="off"
            //                 type="text"
            //                 required
            //                 label="Email ID"
            //                 name="l_email"
            //                 value={formdata?.l_email}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_other_group_name"
            //                 fullWidth
            //                 autoComplete="off"
            //                 type="text"
            //                 label="Other Networking Platform"
            //                 name="other_group_name"
            //                 placeholder="Have you join any Other Networking Platform"
            //                 value={formdata?.other_group_name}
            //                 onChange={onChangeFunction}
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_address"
            //                 fullWidth
            //                 autoComplete="off"
            //                 type="text"
            //                 required
            //                 label="Office Address"
            //                 name="l_address"
            //                 value={formdata?.l_address}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_h_address"
            //                 fullWidth
            //                 autoComplete="off"
            //                 type="text"
            //                 required
            //                 label="Home Address"
            //                 name="l_h_address"
            //                 value={formdata?.l_h_address}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LocalizationProvider dateAdapter={AdapterDateFns}>
            //                 <DatePicker
            //                   type="date"
            //                   name="payment_date"
            //                   label="Payment Date"
            //                   value={
            //                     formdata?.payment_date != undefined
            //                       ? moment(formdata.payment_date, "DD-MM-YYYY")
            //                       : null
            //                   }
            //                   inputFormat="dd/MM/yyyy"
            //                   onChange={(newDate) => {
            //                     setformdata({
            //                       ...formdata,
            //                       payment_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
            //                     });
            //                   }}
            //                   renderInput={(params) => (
            //                     <TextField
            //                       // disabled
            //                       {...params}
            //                       required
            //                     />
            //                   )}
            //                 />
            //               </LocalizationProvider>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <FormControl>
            //                 <FormLabel id="demo-error-radios" className="font-bold">
            //                   Please Select Payment Method{" "}
            //                   <span
            //                     aria-hidden="true"
            //                     className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
            //                   >
            //                     *
            //                   </span>
            //                 </FormLabel>

            //                 <RadioGroup
            //                   row // display as Row
            //                   name="payment_mode"
            //                   value={formdata?.payment_mode}
            //                   required
            //                   onChange={(e) => {
            //                     setformdata({
            //                       ...formdata,
            //                       payment_mode: e.target.value
            //                     });
            //                   }}
            //                 >
            //                   <FormControlLabel value={0} control={<Radio />} label="Cash" />
            //                   <FormControlLabel value={1} control={<Radio />} label="Transfer" />
            //                   <FormControlLabel value={2} control={<Radio />} label="Cheque" />
            //                 </RadioGroup>
            //               </FormControl>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <FormControl variant="standard">
            //                 <FormLabel id="demo-error-radios" className="font-bold">
            //                   Upload Professional Photo{" "}
            //                   <span
            //                     aria-hidden="true"
            //                     class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
            //                   >
            //                     *
            //                   </span>
            //                 </FormLabel>
            //                 <div>
            //                   <label className="file-label" htmlFor="l_professional_photo">
            //                     <Label
            //                       variant="filled"
            //                       color={"primary"}
            //                       className="select-file-label"
            //                     >
            //                       <div className="select-file-label-text">
            //                         Select File
            //                         <AddPhotoAlternate className="select-file-label-icon" />
            //                       </div>
            //                     </Label>
            //                     <input
            //                       id="l_professional_photo"
            //                       type="file"
            //                       hidden
            //                       name="l_professional_photo"
            //                       accept=".jpeg,.jpg,.png,.gif"
            //                       onChange={(e) => handleFileChange(e, "l_professional_photo")}
            //                     />
            //                   </label>
            //                   <div>
            //                     <>
            //                       {formdata?.l_professional_photo && (
            //                         <div
            //                           variant={"ghost"}
            //                           color="success"
            //                           className="upload-file-name"
            //                         >
            //                           {formdata?.l_professional_photo?.name ||
            //                             formdata?.l_professional_photo}
            //                         </div>
            //                       )}
            //                       <Label variant={"ghost"} color="error" className="warning-note">
            //                         More Then 10MB of File Are Not Supported
            //                       </Label>
            //                       <Label variant={"ghost"} color="error" className="warning-note">
            //                         Note: Only Image Supported
            //                       </Label>
            //                     </>
            //                   </div>
            //                 </div>
            //               </FormControl>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <FormControl variant="standard">
            //                 <FormLabel id="demo-error-radios" className="font-bold">
            //                   Upload Your Product Photo{" "}
            //                   <span
            //                     aria-hidden="true"
            //                     class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
            //                   >
            //                     *
            //                   </span>
            //                 </FormLabel>
            //                 <div>
            //                   <label htmlFor="product_image" className="file-label">
            //                     <Label
            //                       variant="filled"
            //                       color={"primary"}
            //                       className="select-file-label"
            //                     >
            //                       <div className="select-file-label-text">
            //                         Select File Product
            //                         <AddPhotoAlternate className="select-file-label-icon" />
            //                       </div>
            //                     </Label>
            //                     <input
            //                       id="product_image"
            //                       type="file"
            //                       hidden
            //                       name="l_product_photo"
            //                       accept=".jpeg,.jpg,.png,.gif,.bmp"
            //                       onChange={(e) => {
            //                         handleFileChange(e, "l_product_photo");
            //                       }}
            //                     />
            //                   </label>
            //                   <div>
            //                     <>
            //                       {formdata?.l_product_photo && (
            //                         <div
            //                           variant={"ghost"}
            //                           color="success"
            //                           className="upload-file-name"
            //                         >
            //                           Productphoto.png
            //                           {formdata?.l_product_photo?.name || formdata?.l_product_photo}
            //                         </div>
            //                       )}

            //                       {/* <div
            //                       style={{
            //                         marginTop: "20px",
            //                         display: "flex",
            //                         justifyContent: "center",
            //                       }}
            //                     >
            //                       <FormHelperText>
            //                         {errors.l_product_photo}
            //                       </FormHelperText>
            //                     </div> */}

            //                       <Label variant={"ghost"} color="error" className="warning-note">
            //                         More Then 10MB of File Are Not Supported
            //                       </Label>
            //                       <Label variant={"ghost"} color="error" className="warning-note">
            //                         Note: Only Image Supported
            //                       </Label>
            //                     </>
            //                   </div>
            //                 </div>
            //               </FormControl>
            //             </Stack>
            //           </Grid>
            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_reference"
            //                 fullWidth
            //                 required
            //                 autoComplete="off"
            //                 type="text"
            //                 label="Reference By (1)"
            //                 name="l_reference_1"
            //                 value={formdata?.l_reference_1}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>

            //           <Grid item xs={12} md={6} className="mb-15">
            //             <Stack spacing={10}>
            //               <LimitedTextField
            //   limitKey="lead_reference"
            //                 fullWidth
            //                 required
            //                 autoComplete="off"
            //                 type="text"
            //                 label="Reference By (2)"
            //                 name="l_reference_2"
            //                 value={formdata?.l_reference_2}
            //                 onChange={onChangeFunction}
            //                 autoCorrect="off"
            //               />
            //             </Stack>
            //           </Grid>
            //         </>
            //       )}
            //     </Grid>
            //     {/* Submit and next , back handle */}
            //     <div className="edit-lead-form-footer">
            //       {activeTab == 1 && (
            //         <Button
            //           variant="contained"
            //           className="my-auto mx-5"
            //           // onClick={async (e) => {
            //           //   // checkValidation();
            //           // }}
            //           onClick={() => setActiveTab(2)}
            //         >
            //           Next
            //         </Button>
            //       )}

            //       {activeTab == 2 && (
            //         <>
            //           <Button
            //             variant="outlined"
            //             className="my-auto mx-5"
            //             onClick={() => setActiveTab(1)}
            //           >
            //             Back
            //           </Button>
            //           <Button
            //             variant="contained"
            //             className="my-auto mx-5"
            //             // onClick={async () => {
            //             //   checkValidation(1);
            //             //   checkValidation(2);
            //             // }}
            //             disabled={isLoading}
            //             onClick={submitformdata}
            //           >
            //             Submit
            //             {isLoading && (
            //               <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
            //             )}
            //           </Button>
            //         </>
            //       )}
            //     </div>
            //   </Card>
            // </>
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setformdata({ l_created_by: loginUser.u_id, l_type: 0 });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card className="p-20">
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={activeTab}
                    variant="fullWidth"
                    allowScrollButtonsMobile
                    onChange={
                      (e, value) => {
                        // checkValidation(value);
                        setActiveTab(value);
                      }
                      // setMemberDetailData([]),
                      // setActiveTab(value),
                      // getMembersDetailReport(value, activeRow.m_id)
                    }
                  >
                    <Tab
                      className="mb-0 pb-0"
                      disableRipple
                      key={1}
                      value={1}
                      label="Personal / Business Details"
                      icon={<Person />}
                      iconPosition="start"
                    />
                    {/* <Tab
                      className="mb-0 pb-0"
                      disableRipple
                      key={2}
                      value={2}
                      label="Business Details"
                      icon={<Business />}
                      iconPosition="start"
                    /> */}
                  </Tabs>
                </Box>
                <Grid container spacing={2} className="mt-10">
                  {activeTab == 1 ? (
                    <>
                      <Grid item xs={6}>
                        <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">Gender</FormLabel>

                            <RadioGroup
                              name="gender"
                              row // remove this if you want vertical
                              value={formdata.gender || 0}
                              onChange={onChangeFunction}
                            >
                              {gender
                                .filter((g) => g.value !== 0) // remove "Select Gender"
                                .map((g) => (
                                  <FormControlLabel
                                    key={g.value}
                                    value={g.value}
                                    control={<Radio />}
                                    label={g.label}
                                  />
                                ))}
                            </RadioGroup>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_name"
                            style={{ marginTop: "0px" }}
                            fullWidth
                            required
                            autoComplete="off"
                            type="text"
                            label="Full Name"
                            name="name"
                            value={formdata?.name}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_contact_no"
                            fullWidth
                            required
                            autoComplete="off"
                            type="text"
                            label="Contact Number"
                            name="l_contact_no"
                            value={formdata?.l_contact_no}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_business_name"
                            fullWidth
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            required
                            label="Company Name"
                            name="l_business_name"
                            value={formdata?.l_business_name || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>

                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_business_category"
                            fullWidth
                            required
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            label="Business Category"
                            name="l_business_category"
                            value={formdata?.l_business_category || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_email"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            required
                            label="Email ID"
                            name="l_email"
                            value={formdata?.l_email || ""}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      {/* <Grid item xs={6} className="mb-15">
                        <Stack spacing={10}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              type="date"
                              name="dob"
                              label="Date of Birth"
                              value={
                                formdata?.dob != undefined
                                  ? moment(formdata.dob, "DD-MM-YYYY")
                                  : null
                              }
                              disableFuture
                              inputFormat="dd/MM/yyyy"
                              onChange={(newDate) => {
                                setformdata({
                                  ...formdata,
                                  dob: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                });
                              }}
                              renderInput={(params) => <TextField {...params} required />}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid> */}

                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_alt_contact_no"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="Alternate Contact Number"
                            name="alternate_contact_number"
                            value={formdata?.alternate_contact_number}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl>
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Please Select Insurance you have
                              <span
                                aria-hidden="true"
                                className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>
                            <FormGroup name="insuranceType">
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={1}
                                control={
                                  <Checkbox
                                    checked={formdata?.insuranceType?.includes("1")}
                                    name="Health_Insurance"
                                  />
                                }
                                label="Health Insurance"
                              />
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={2}
                                control={
                                  <Checkbox
                                    name="Life_Insurance"
                                    checked={formdata?.insuranceType?.includes("2")}
                                  />
                                }
                                label="Life Insurance"
                              />
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={3}
                                control={
                                  <Checkbox
                                    name="Term_Insurance"
                                    checked={formdata?.insuranceType?.includes("3")}
                                  />
                                }
                                label="Term Insurance"
                              />
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={4}
                                control={
                                  <Checkbox
                                    name="None"
                                    checked={formdata?.insuranceType?.includes("4")}
                                  />
                                }
                                label="None"
                              />
                              <FormControlLabel
                                value={0}
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                control={
                                  <Checkbox
                                    name="Other"
                                    checked={formdata?.insuranceType?.includes("0")}
                                  />
                                }
                                label="Other"
                              />

                              {formdata?.insuranceType?.includes("0") && (
                                <LimitedTextField
                                  limitKey="lead_other_insurance"
                                  // label="Other Option"
                                  variant="standard"
                                  fullWidth
                                  autoComplete="off"
                                  autoCorrect="off"
                                  name="otherInsurance"
                                  placeholder="Other Insurance"
                                  value={formdata?.otherInsurance}
                                  onChange={onChangeFunction}
                                />
                              )}
                            </FormGroup>
                          </FormControl>
                        </Stack>
                      </Grid> */}
                      <Grid item xs={12} md={12} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl variant="standard">
                            <FormLabel id="demo-error-radios" className="label-bold">
                              Select Aadhaar Card Front & Back Photo{" "}
                              <span
                                aria-hidden="true"
                                className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>
                            <div>
                              <label className="file-label" htmlFor="file">
                                <Label
                                  variant="filled"
                                  color={undefined}
                                  className="select-file-label"
                                >
                                  <div className="select-file-label-text">
                                    Select File
                                    <AddPhotoAlternate className="select-file-label-icon" />
                                  </div>
                                </Label>
                                <input
                                  id="file"
                                  type="file"
                                  hidden
                                  name="aadhaar"
                                  accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
                                  onChange={(e) => {
                                    handleFileChange(e, "aadhaar");
                                  }}

                                // onBlur={checkValidation}
                                />
                              </label>
                              <div>
                                <>
                                  {formdata?.aadhaar && (
                                    <div>
                                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                                        <Box
                                          sx={{
                                            // mt: 1,
                                            width: "40%",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1

                                            // p: 1
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              flex: 1,
                                              minWidth: 0
                                            }}
                                          >
                                            <Box sx={{ ml: 1, minWidth: 0 }}>
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis"
                                                }}
                                              >
                                                {formdata?.aadhaar?.name || formdata?.aadhaar}
                                              </Typography>
                                            </Box>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "1px",
                                              flexShrink: 0
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              onClick={() => {
                                                const file = formdata?.aadhaar;
                                                const url = formdata?.aadhaar;

                                                if (file instanceof File) {
                                                  const fileURL = URL.createObjectURL(file);
                                                  window.open(fileURL, "_blank");
                                                } else if (url) {
                                                  window.open(
                                                    `${Routes.API_HOSTNAME}images/leadMemberAadhaar/${url}`,
                                                    "_blank"
                                                  );
                                                }
                                              }}
                                            >
                                              <VisibilityIcon fontSize="small" />
                                            </Button>
                                            <Button
                                              size="small"
                                              color="error"
                                              onClick={() =>
                                                deleteLeadAttachmentHandler(
                                                  formdata?.lead_id,
                                                  "aadhaar",
                                                  formdata?.aadhaar
                                                )
                                              }
                                            >
                                              <CloseIcon fontSize="small" />
                                            </Button>
                                          </Box>
                                        </Box>
                                      </Box>
                                    </div>
                                  )}

                                  {/* Input Helper */}
                                  {/* <Label variant={"ghost"} color="error" className="warning-note">
                                    More Then 10MB of File Are Not Supported
                                  </Label> */}

                                  <Label variant={"ghost"} color="primary" className="warning-note">
                                    Note: PDF, Doc & Images are Only Supported
                                  </Label>
                                </>
                              </div>
                            </div>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={12} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_gst_no"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="GST No"
                            name="gst_no"
                            value={formdata?.gst_no || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>

                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_other_group_name"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="Other Networking Platform"
                            name="other_group_name"
                            placeholder="Have you join any Other Networking Platform"
                            value={formdata?.other_group_name || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid> */}
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_address"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            required
                            label="Office Address"
                            name="l_address"
                            value={formdata?.l_address || ""}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid> */}
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_h_address"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            required
                            label="Home Address"
                            name="l_h_address"
                            value={formdata?.l_h_address || ""}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid> */}
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              type="date"
                              name="payment_date"
                              label="Payment Date"
                              value={
                                formdata?.payment_date != undefined
                                  ? moment(formdata.payment_date, "DD-MM-YYYY")
                                  : null
                              }
                              inputFormat="dd/MM/yyyy"
                              onChange={(newDate) => {
                                setformdata({
                                  ...formdata,
                                  payment_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // disabled
                                  {...params}
                                  required
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl>
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Please Select Payment Method{" "}
                              <span
                                aria-hidden="true"
                                className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>

                            <RadioGroup
                              row // display as Row
                              name="payment_mode"
                              value={formdata?.payment_mode}
                              required
                              onChange={(e) => {
                                setformdata({
                                  ...formdata,
                                  payment_mode: e.target.value
                                });
                              }}
                            >
                              <FormControlLabel value={0} control={<Radio />} label="Cash" />
                              <FormControlLabel value={1} control={<Radio />} label="Transfer" />
                              <FormControlLabel value={2} control={<Radio />} label="Cheque" />
                            </RadioGroup>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl variant="standard">
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Upload Payment Screenshot / Cheque Photo{" "}
                              <span
                                aria-hidden="true"
                                class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>
                            <div>
                              <label htmlFor="payment_photo" className="file-label">
                                <Label
                                  variant="filled"
                                  color={undefined}
                                  className="select-file-label"
                                >
                                  <div className="select-file-label-text">
                                    Select File
                                    <AddPhotoAlternate className="select-file-label-icon" />
                                  </div>
                                </Label>
                                <input
                                  id="payment_photo"
                                  type="file"
                                  hidden
                                  multiple
                                  name="l_payment_photo"
                                  accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
                                  onChange={(e) => {
                                    handleFileChange(e, "l_payment_photo");
                                  }}
                                />
                              </label>
                              <div className="mt-1">
                                <>
                                  {/* {formdata?.l_payment_photo && (
                                                              <div
                                                                variant={"ghost"}
                                                                color="success"
                                                                className="upload-file-name"
                                                              >
                                                                Productphoto.png
                                                                {formdata?.l_payment_photo?.name || formdata?.l_payment_photo}
                                                              </div>
                                                            )} */}

                                  {
                                    Array.isArray(formdata?.l_payment_photo) &&
                                    formdata?.l_payment_photo.map((file, index) => (
                                      <div>
                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                          <Box
                                            sx={{
                                              mt: 1,
                                              width: "80%",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              border: "1px solid #e0e0e0",
                                              borderRadius: 1
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                flex: 1,
                                                minWidth: 0
                                              }}
                                            >
                                              <Box sx={{ ml: 1, minWidth: 0 }}>
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                  }}
                                                >
                                                  {file?.name || file}
                                                </Typography>
                                              </Box>
                                            </Box>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "1px",
                                                flexShrink: 0
                                              }}
                                            >
                                              <Button
                                                size="small"
                                                onClick={() => {
                                                  const url = file;

                                                  if (file instanceof File) {
                                                    const fileURL = URL.createObjectURL(file);
                                                    window.open(fileURL, "_blank");
                                                  } else if (url) {
                                                    window.open(
                                                      `${Routes.API_HOSTNAME}images/leadMemberPayment/${url}`,
                                                      "_blank"
                                                    );
                                                  }
                                                }}
                                              >
                                                <VisibilityIcon fontSize="small" />
                                              </Button>
                                              <Button
                                                size="small"
                                                color="error"
                                                onClick={() =>
                                                  deleteLeadAttachmentHandler(
                                                    formdata?.lead_id,
                                                    "l_payment_photo",
                                                    file,

                                                    formdata.l_payment_photo_id[index],
                                                    index
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </div>
                                    ))
                                    // : formdata?.l_payment_photo && (
                                    //     <div
                                    //       variant={"ghost"}
                                    //       color="success"
                                    //       className="upload-file-name"
                                    //     >
                                    //       {formdata?.l_payment_photo?.name ||
                                    //         formdata?.l_payment_photo}
                                    //     </div>
                                    //   )
                                  }

                                  {/* <div
                                                            style={{
                                                              marginTop: "20px",
                                                              display: "flex",
                                                              justifyContent: "center",
                                                            }}
                                                          >
                                                            <FormHelperText>
                                                              {errors.l_product_photo}
                                                            </FormHelperText>
                                                          </div> */}

                                  {/* <Label variant={"ghost"} color="error" className="warning-note">
                                                              More Then 10MB of File Are Not Supported
                                                            </Label> */}
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center"
                                    }}
                                  >
                                    <Label
                                      variant={"ghost"}
                                      color="primary"
                                      style={{
                                        margin: "0",
                                        display: "flex",
                                        marginTop: "10px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "fit-content",
                                        paddingBottom: "5px",
                                        paddingTop: "5px",
                                        fontSize: "14px"
                                      }}
                                    >
                                      Note: PDF, Doc & Images are Only Supported
                                    </Label>
                                  </div>
                                </>
                              </div>
                            </div>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl variant="standard">
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Upload Professional Photo{" "}
                              <span
                                aria-hidden="true"
                                class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>
                            <div>
                              <label className="file-label" htmlFor="l_professional_photo">
                                <Label
                                  variant="filled"
                                  color={undefined}
                                  className="select-file-label"
                                >
                                  <div className="select-file-label-text">
                                    Select File
                                    <AddPhotoAlternate className="select-file-label-icon" />
                                  </div>
                                </Label>
                                <input
                                  id="l_professional_photo"
                                  type="file"
                                  hidden
                                  name="l_professional_photo"
                                  accept=".jpeg,.jpg,.png,.gif"
                                  onChange={(e) => handleFileChange(e, "l_professional_photo")}
                                />
                              </label>
                              <div>
                                <>
                                  {formdata?.l_professional_photo && (
                                    <div>
                                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                                        <Box
                                          sx={{
                                            mt: 1,
                                            width: "80%",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              flex: 1,
                                              minWidth: 0
                                            }}
                                          >
                                            <Box sx={{ ml: 1, minWidth: 0 }}>
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis"
                                                }}
                                              >
                                                {formdata?.l_professional_photo?.name ||
                                                  formdata?.l_professional_photo}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "1px",
                                              flexShrink: 0
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              onClick={() => {
                                                const url = formdata?.l_professional_photo;

                                                if (url instanceof File) {
                                                  const fileURL = URL.createObjectURL(url);
                                                  window.open(fileURL, "_blank");
                                                } else if (url) {
                                                  window.open(
                                                    `${Routes.API_HOSTNAME}images/leadMemberProfile/${url}`,
                                                    "_blank"
                                                  );
                                                }
                                              }}
                                            >
                                              <VisibilityIcon fontSize="small" />
                                            </Button>
                                            <Button
                                              size="small"
                                              color="error"
                                              onClick={() =>
                                                deleteLeadAttachmentHandler(
                                                  formdata?.lead_id,
                                                  "l_professional_photo",
                                                  formdata?.l_professional_photo
                                                )
                                              }
                                            >
                                              <CloseIcon fontSize="small" />
                                            </Button>
                                          </Box>
                                        </Box>
                                      </Box>
                                    </div>
                                  )}
                                  {/* <Label variant={"ghost"} color="error" className="warning-note">
                                    More Then 10MB of File Are Not Supported
                                  </Label> */}
                                  <Label variant={"ghost"} color="primary" className="warning-note">
                                    Note: Only Image Supported
                                  </Label>
                                </>
                              </div>
                            </div>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_reference"
                            fullWidth
                            required
                            autoComplete="off"
                            type="text"
                            label="Reference By (1)"
                            name="l_reference_1"
                            value={formdata?.l_reference_1}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>

                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_reference"
                            fullWidth
                            required
                            autoComplete="off"
                            type="text"
                            label="Reference By (2)"
                            name="l_reference_2"
                            value={formdata?.l_reference_2}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <TextField
                            fullWidth
                            type="text"
                            label="Enter Facebook ID"
                            name="facebook_url"
                            value={formdata?.facebook_url || ""}
                            onChange={onChangeFunction}
                            autoComplete="off"
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <TextField
                            fullWidth
                            type="text"
                            label="Enter Instagram ID"
                            name="instagram_url"
                            value={formdata?.instagram_url || ""}
                            onChange={onChangeFunction}
                            autoComplete="off"
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid> */}
                    </>
                  ) : (
                    <>
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_business_description"
                            fullWidth
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            label="Business Description"
                            name="l_business_description"
                            value={formdata?.l_business_description || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid> */}
                    </>
                  )}
                </Grid>
                {/* Submit and next , back handle */}
                <div className="edit-lead-form-footer">
                  {/* {activeTab == 1 && (
                    <Button
                      variant="contained"
                      className="my-auto mx-5"
                      // onClick={async (e) => {
                      //   // checkValidation();
                      // }}
                      onClick={() => setActiveTab(2)}
                    >
                      Next
                    </Button>
                  )} */}

                  {/* {activeTab == 2 && (
                    <>
                      <Button
                        variant="outlined"
                        className="my-auto mx-5"
                        onClick={() => setActiveTab(1)}
                      >
                        Back
                      </Button> */}
                  <Button
                    variant="contained"
                    className="my-auto mx-5"
                    // onClick={async () => {
                    //   checkValidation(1);
                    //   checkValidation(2);
                    // }}
                    disabled={isLoading}
                    onClick={submitformdata}
                  >
                    Submit
                    {isLoading && (
                      <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                    )}
                  </Button>
                  {/* </>
                  )} */}
                </div>
              </Card>
            </>
          ) : (
            <>
              <Card className="p-20">
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <TextField
                        fullWidth
                        value={filterlead?.filterl}
                        autoComplete="off"
                        size="small"
                        type="text"
                        label="Search Lead"
                        name="search"
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            filterl: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="s_date"
                          label="Start Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            filterlead.s_date != null
                              ? moment(filterlead.s_date, "DD-MM-YYYY")
                              : null
                          }
                          onChange={(newDate) => {
                            setfilterlead({
                              ...filterlead,
                              s_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                            });
                          }}
                          renderInput={(params) => <TextField {...params} size="small" />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="e_date"
                          label="End Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            filterlead.e_date != null
                              ? moment(filterlead.e_date, "DD-MM-YYYY")
                              : null
                          }
                          // onChange={setnewformdata}
                          onChange={(newDate) => {
                            setfilterlead({
                              ...filterlead,
                              e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                            });
                          }}
                          renderInput={(params) => <TextField {...params} size="small" />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  {(loginUser?.u_type == 0 ||
                    (loginUser?.u_type == 0 && loginUser?.is_subadmin == 1)) && (
                      <Grid item xs={3}>
                        <Stack spacing={3}>
                          <label>Select City</label>
                          <Select
                            isDisabled={
                              loginUser?.u_type == 1 ||
                                (loginUser?.u_type == 2 &&
                                  loginUser?.p_user_id != 1 &&
                                  loginUser?.management_p == 1)
                                ? true
                                : false
                            }
                            value={
                              filterlead.filterCity == 0
                                ? {
                                  value: 0,
                                  label: "All City"
                                }
                                : allCityList.map((city) => {
                                  return (
                                    filterlead.filterCity == city.city_id && {
                                      value: city.city_id,
                                      label: city.city_name
                                    }
                                  );
                                })
                            }
                            onChange={(e) => {
                              setfilterlead({
                                ...filterlead,
                                filterCity: e.value,
                                filterchap: 0
                              });
                            }}
                            options={[
                              {
                                value: 0,
                                label: "All City"
                              },
                              ...allCityList.map((city) => {
                                return {
                                  label: city?.city_name,
                                  value: city?.city_id
                                };
                              })
                            ]}
                            menuPortalTarget={document.body}
                          />
                        </Stack>
                      </Grid>
                    )}

                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select User</label>
                      <Select
                        value={filterOption?.map((st) => {
                          if (st.value == filterlead.filteruser) {
                            return { value: st.value, label: st.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            filteruser: e.value
                          });
                        }}
                        options={filterOption}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select Lead Status</label>
                      <Select
                        //filter.lead_status
                        value={
                          filterlead.lead_status == -1
                            ? { value: -1, label: "All Lead" }
                            : statusList?.map((st) => {
                              if (st.a_id == filterlead.lead_status) {
                                return { value: st.a_id, label: st.name };
                              }
                            })
                        }
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            lead_status: e.value
                          });
                        }}
                        options={[
                          { value: -1, label: "All Lead" },
                          ...statusList
                            ?.filter(
                              (item) =>
                                item.a_id == 3 || item.a_id == 9 || item.a_id == 8 || item.a_id == 4
                            )
                            .map((st) => ({
                              value: st.a_id,
                              label: st.name
                            }))
                        ]}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select Lead Type</label>
                      <Select
                        value={LeadSearchTypeOptions?.map((st) => {
                          if (st.value == filterlead.lead_type) {
                            return { value: st.value, label: st.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({ ...filterlead, lead_type: e.value });
                        }}
                        options={LeadSearchTypeOptions}
                      />
                    </Stack>
                  </Grid>
                  {/* <Grid item xs={3}></Grid> */}
                  <Grid item xs={2}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around"
                      }}
                    >
                      <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setLoadingMoreData(-1);
                          getFilterLeadData();
                        }}
                        variant="contained"
                      >
                        search
                      </Button>
                      <Button
                        onClick={async () => {
                          await setLoadingMoreData(-1);

                          await setfilterlead({
                            u_id: loginUser.u_id,
                            u_type: loginUser.u_type,
                            filterl: "",
                            s_date: null,
                            e_date: null,
                            filteruser: 0,
                            l_phase: -1,
                            lead_status: -1,
                            lead_type: -1
                          });
                          await resetSearchForm({
                            u_id: loginUser.u_id,
                            u_type: loginUser.u_type,
                            filterl: "",
                            s_date: null,
                            e_date: null,
                            filteruser: 0,
                            l_phase: -1,
                            lead_status: -1,
                            lead_type: -1
                          });
                        }}
                        variant="contained"
                      >
                        clear
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Card>

              {step == 0 &&
                (boardLoading ? (
                  <CustomLoader />
                ) : (
                  <Board
                    className="taskList"
                    data={leadList}
                    style={{ position: "relative", marginTop: "15px" }}
                    cardDragClass="kanban-drag-card"
                    components={{
                      LaneHeader: (props) => (
                        <CustomLaneHeader
                          {...props}
                          setLeadStatusData={setLeadStatusData}
                          setLeadStatusDescriptionViewModal={setLeadStatusDescriptionViewModal}
                        />
                      ),
                      Card: CustomCard
                    }}
                    onCardClick={
                      async (cardId, metadata, phase) => {
                        setValue("1");
                        setMyModal({
                          mval: true,
                          lead_id: cardId,
                          l_phase: phase
                        });
                        setLeadHistory(await featchleadhistory(cardId));
                        setExpanded(0);
                      }
                      // alert(`Card with id:${cardId} clicked. Has metadata.id: ${metadata.id}`)
                    }
                    handleDragEnd={async (
                      id,
                      sourceLaneId,
                      targetLaneId,
                      position,
                      cardDetails
                    ) => {
                      await leadStatusChange(id, targetLaneId, sourceLaneId);
                    }}
                    onLaneScroll={(requestedPage, laneId) => handleCustomLaneScroll(laneId, false)}
                  />
                ))}
              {step == 3 && newleadData && (
                <>
                  <Button className="btn btn-export">
                    <CSVLink
                      data={newleadData}
                      headers={expo_columns}
                      filename={"LeadData.csv"}
                      className="btn btn-primary test"
                      target="_blank"
                    >
                      Export CSV
                    </CSVLink>
                  </Button>
                  <DataTable
                    title="Lead List"
                    filter
                    pagination
                    highlightOnHover
                    columns={columns}
                    data={newleadData}
                  />
                </>
              )}
            </>
          )}
        </Container>
      </Page>

      {leadStatusDescriptionViewModal && (
        <LeadStatusDescriptionViewModal
          leadStatusData={leadStatusData}
          leadStatusDescriptionViewModal={leadStatusDescriptionViewModal}
          setLeadStatusDescriptionViewModal={setLeadStatusDescriptionViewModal}
        />
      )}
    </>
  );
}
